import type { CSSObject } from '@mui/material/styles';
import { createFocusRingStyles, createMotionTransition } from '../interaction';
import { designTokens } from '../tokens';

/** 선택 버튼과 탭이 공유하는 연결된 rail 표면입니다. */
export const segmentedControlRailStyles: CSSObject = {
  borderRadius: designTokens.radius.pill,
  backgroundColor: designTokens.color.subtleSurface,
  '@media (forced-colors: active)': { backgroundColor: 'Canvas' },
};

/** 역할·선택·키보드는 각 컴포넌트가 소유하며 선택 표면만 함께 사용합니다. */
export const segmentedControlItemStyles: CSSObject = {
  position: 'relative', isolation: 'isolate', flex: '0 0 auto',
  minWidth: designTokens.layout.controlMinHeight,
  minHeight: designTokens.layout.controlMinHeight,
  [designTokens.media.touchTarget]: { minWidth: designTokens.layout.touchTargetMinSize, minHeight: designTokens.layout.touchTargetMinSize },
  paddingInline: `${designTokens.space.md}px`, paddingBlock: 0,
  borderRadius: designTokens.radius.pill,
  color: designTokens.color.secondaryText,
  ...designTokens.typography.ui, fontWeight: 600, whiteSpace: 'nowrap',
  '&[data-icon-only="true"]': { paddingInline: 0 },
  '&::before': {
    content: '""', position: 'absolute', inset: `${designTokens.space.xxs}px`, zIndex: -1,
    borderRadius: 'inherit', backgroundColor: 'transparent',
    border: '1px solid', borderColor: 'transparent', boxShadow: 'none',
    transition: createMotionTransition(['background-color', 'box-shadow'], 'tab'),
  },
  '&:hover::before': { backgroundColor: designTokens.color.hoverSurface },
  '&.Mui-selected, &[aria-pressed="true"]': {
    color: designTokens.color.actionDark,
    '&::before': { backgroundColor: designTokens.color.compactSelectedSurface, borderColor: designTokens.color.brandBorder, boxShadow: designTokens.shadow.surface },
    '&:hover::before': { backgroundColor: designTokens.color.selectedHoverSurface },
  },
  '&:focus-visible, &.Mui-focusVisible': createFocusRingStyles({ inset: true }),
  '&:disabled, &.Mui-disabled': { opacity: designTokens.button.disabledOpacity },
  '@media (forced-colors: active)': {
    forcedColorAdjust: 'none', color: 'ButtonText',
    '&::before, &:hover::before': { backgroundColor: 'Canvas', boxShadow: 'none', border: '1px solid ButtonText' },
    '&.Mui-selected, &[aria-pressed="true"]': {
      color: 'HighlightText',
      '&::before, &:hover::before': { backgroundColor: 'Highlight', boxShadow: 'none', border: '1px solid ButtonText' },
    },
    '&:disabled, &.Mui-disabled': { opacity: 1, color: 'GrayText', '&::before': { backgroundColor: 'Canvas', borderColor: 'GrayText' } },
  },
};
